
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"restaurantPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"movedTo"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templatedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuSections"}},{"kind":"Field","name":{"kind":"Name","value":"meals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuSection"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantDetailsMetaData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantInfo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Map"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Delivery"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OpenHours"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Menu"}}]}}]}}],"loc":{"start":0,"end":1203}};
    doc.loc.source = {"body":"# The new restaurant page (W3.1): the original page's fragments unchanged, plus\n# additive fields. Used only when ENABLE_NEW_DETAIL_PAGES is on, so the old\n# page's query (and its server-rendered Apollo state) is untouched.\n#import \"../restaurant-details/components/meta-data/MetaData.graphql\"\n#import \"../restaurant-details/components/contact-details/ContactDetails.graphql\"\n#import \"../restaurant-details/components/restaurant-info/RestaurantInfo.graphql\"\n#import \"../restaurant-details/components/delivery/Delivery.graphql\"\n#import \"../restaurant-details/components/map/Map.graphql\"\n#import \"../restaurant-details/components/open-hours/OpenHours.graphql\"\n#import \"../restaurant-details/components/menu/Menu.graphql\"\n\nquery restaurantPage($id: String) {\n  restaurant(id: $id) {\n    movedTo\n    website\n    # W2.6: the owner's description and photos (first = main).\n    description\n    images {\n      id\n      templatedUrl\n    }\n    # W2.6: the owner's menu categories in order; each meal's section joins one.\n    menuSections\n    meals {\n      menuSection\n    }\n    ...RestaurantDetailsMetaData\n    ...RestaurantInfo\n    ...Map\n    ...ContactDetails\n    ...Delivery\n    ...OpenHours\n    ...Menu\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("../restaurant-details/components/meta-data/MetaData.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../restaurant-details/components/contact-details/ContactDetails.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../restaurant-details/components/restaurant-info/RestaurantInfo.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../restaurant-details/components/delivery/Delivery.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../restaurant-details/components/map/Map.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../restaurant-details/components/open-hours/OpenHours.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../restaurant-details/components/menu/Menu.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["restaurantPage"] = oneQuery(doc, "restaurantPage");
        
